/** Final status belongs to a local send, not to the passive conversation stream. */
export async function cancelLocalSendForFinalStatus(
  isSending: boolean,
  cancelStream: () => void | Promise<void>,
): Promise<void> {
  if (isSending) await cancelStream();
}
